export abstract class Repository {
  constructor() {}
}
